module.exports = __webpack_public_path__ + "img/fire.6bfb9f9a.png";